import BaseInputsContainer from "../../../../../Components/Forms&Table/Forms/FormControls/BaseInput/BaseInputContainer";

const BaseInput = () => {
  return <BaseInputsContainer />;
};

export default BaseInput;
